"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _elements = require("../../styles/elements");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Ai = require("./Ai.styles");

var _shared = require("./shared");

var AiErrorPanel = function AiErrorPanel(_ref) {
  var onRetry = _ref.onRetry,
      onCancel = _ref.onCancel,
      className = _ref.className,
      bare = _ref.bare;
  var content = (0, _jsxRuntime.jsxs)(_shared.Controls, {
    css: [_Ai.styles.controls, bare && _Ai.styles.bareControls, process.env.NODE_ENV === "production" ? "" : ";label:content;"],
    children: [(0, _jsxRuntime.jsx)(_Button["default"], {
      type: "info",
      size: "small",
      onClick: onRetry,
      children: "Try again"
    }), (0, _jsxRuntime.jsx)(_Button["default"], {
      type: "warningOutline",
      size: "small",
      onClick: onCancel,
      children: "Cancel"
    })]
  });

  if (bare) {
    return content;
  }

  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)("div", {
      css: _elements.divider.styles.base,
      role: "separator"
    }), (0, _jsxRuntime.jsx)(_shared.Container, {
      className: (0, _clsx["default"])(className, 'grui'),
      children: content
    })]
  });
};

AiErrorPanel.propTypes = {
  onRetry: _propTypes.func,
  onCancel: _propTypes.func,
  className: _propTypes.string,
  bare: _propTypes.bool
};
AiErrorPanel.defaultProps = {
  onRetry: function onRetry() {},
  onCancel: function onCancel() {},
  className: '',
  bare: false
};
var _default = AiErrorPanel;
exports["default"] = _default;
//# sourceMappingURL=AiErrorPanel.js.map